import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "icon-fill-primary",
		d: "M30.5 28.5L24.8 4.9v-.1C23.7 1.9 21 0 18 0s-5.8 1.9-6.8 4.8L5.6 28.1c-.2.5-.3 1-.4 1.5v.1C5 30.4 5 31.2 5 32c0 7.2 5.8 13 13 13s13-5.8 13-13c0-1.2-.2-2.4-.5-3.5zM11.1 15.8c1.3-2.6 3.9-4.3 6.9-4.3 3 0 5.8 1.8 7 4.5l1.5 6.1c-2.3-2-5.3-3.2-8.5-3.2s-6.1 1.2-8.4 3.1l1.5-6.2zm2.5-10.2c.7-1.9 2.4-3.1 4.4-3.1 2 0 3.7 1.2 4.4 3.1l1.3 5.2C22 9.7 20 9 18 9c-2.1 0-4 .6-5.6 1.7l1.2-5.1zM18 42.5c-5.8 0-10.5-4.7-10.5-10.5S12.2 21.5 18 21.5 28.5 26.2 28.5 32 23.8 42.5 18 42.5z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "icon-fill-primary",
		d: "M18 24.4c-4.2 0-7.6 3.4-7.6 7.6 0 4.2 3.4 7.6 7.6 7.6 4.2 0 7.6-3.4 7.6-7.6 0-4.2-3.4-7.6-7.6-7.6zm0 12.7c-2.8 0-5.1-2.3-5.1-5.1s2.3-5.1 5.1-5.1 5.1 2.3 5.1 5.1-2.3 5.1-5.1 5.1z"
	})] }), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 35.7,
			y: 7.9,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 5.4
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 35.7,
			y: 15.8,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 5.4
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 35.7,
			y: 23.8,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 5.4
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 35.7,
			y: 31.7,
			className: "icon-fill-secondary",
			width: 2.5,
			height: 5.4
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-secondary",
			points: "37 0 33.9 5.3 40 5.3"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-secondary",
			points: "37 45 40 39.7 33.9 39.7"
		})
	] })]
});
export default SvgIcon;
